/**
 * @generated SignedSource<<d7dfa949ce54f582b48b81b9bd81950e>>
 * @relayHash 0640a2a61e3e8f7d4ceb7f19bb6d2b2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83ce0dd517e94d5ac246c15e09e49e0750acaaf81f47774c953ad3220b795aa1

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccessType = "EDIT" | "VIEW" | "%future added value";
export type RequestAccessPopupRequestAccessMutation$variables = {
  accessType: AccessType;
  pageId: string;
};
export type RequestAccessPopupRequestAccessMutation$data = {
  readonly requestPageAccess: {
    readonly displayName: string;
  } | null | undefined;
};
export type RequestAccessPopupRequestAccessMutation = {
  response: RequestAccessPopupRequestAccessMutation$data;
  variables: RequestAccessPopupRequestAccessMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "accessType",
            "variableName": "accessType"
          },
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
          }
        ],
        "kind": "ObjectValue",
        "name": "requestPageAccessInput"
      }
    ],
    "concreteType": "RequestPageAccessPayload",
    "kind": "LinkedField",
    "name": "requestPageAccess",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "displayName"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RequestAccessPopupRequestAccessMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestAccessPopupRequestAccessMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0640a2a61e3e8f7d4ceb7f19bb6d2b2d",
    "id": "83ce0dd517e94d5ac246c15e09e49e0750acaaf81f47774c953ad3220b795aa1",
    "metadata": {},
    "name": "RequestAccessPopupRequestAccessMutation",
    "operationKind": "mutation",
    "text": "mutation RequestAccessPopupRequestAccessMutation($accessType:AccessType!,$pageId:String!){requestPageAccess(requestPageAccessInput:{accessType:$accessType,pageId:$pageId}){displayName}}"
  }
};
})();

(node as any).hash = "9050f8425b5f70e7c2b37bdeef0402c8";

export default node;
